import { render, staticRenderFns } from "./Dangersrc.vue?vue&type=template&id=90ceebf2&scoped=true"
import script from "./Dangersrc.vue?vue&type=script&lang=js"
export * from "./Dangersrc.vue?vue&type=script&lang=js"
import style0 from "./Dangersrc.vue?vue&type=style&index=0&id=90ceebf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ceebf2",
  null
  
)

export default component.exports